import type { ScanAnalyticsScope } from "types/scanAnalytics";

function scopeKey(scope?: ScanAnalyticsScope): string {
  if (!scope) return "";
  return [
    scope.employeeScopeId ?? "",
    scope.companyScopeId ?? "",
    scope.individualScopeId ?? "",
  ].join(":");
}

export const queryKeys = {
  company: {
    accountType: (companyId: string | number) =>
      ["company", "accountType", companyId] as const,
  },
  packages: {
    all: ["packages"] as const,
  },
  license: {
    dashboard: (companyId?: number | string) =>
      ["license", "dashboard", companyId] as const,
  },
  dashboard: {
    admin: ["dashboard", "admin"] as const,
    scanAnalytics: (period: string, scope?: ScanAnalyticsScope) =>
      ["dashboard", "scanAnalytics", period, scopeKey(scope)] as const,
    recentScans: (
      scope: ScanAnalyticsScope | undefined,
      page: number,
      pageSize: number,
      filters: { from?: string | null; to?: string | null; employeeId?: string | null }
    ) =>
      [
        "dashboard",
        "recentScans",
        scopeKey(scope),
        page,
        pageSize,
        filters.from ?? "",
        filters.to ?? "",
        filters.employeeId ?? "",
      ] as const,
  },
} as const;
